/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Newtask1Inputs */

const zh_sidebar_newtask1 = /** @type {(inputs: Sidebar_Newtask1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新建任务`)
};

const en_sidebar_newtask1 = /** @type {(inputs: Sidebar_Newtask1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Task`)
};

const es_sidebar_newtask1 = /** @type {(inputs: Sidebar_Newtask1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva Tarea`)
};

/**
* | output |
* | --- |
* | "New Task" |
*
* @param {Sidebar_Newtask1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const sidebar_newtask1 = /** @type {((inputs?: Sidebar_Newtask1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Newtask1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_newtask1(inputs)
	if (locale === "en") return en_sidebar_newtask1(inputs)
	return es_sidebar_newtask1(inputs)
});
export { sidebar_newtask1 as "sidebar_newTask" }